// DOM overlay: poster, loading, title, time of day, the dock at the bottom (tour, rooms, overview, more), its menu,
// guide cards, toasts, fades. German copy. Everything floating takes colours, radius and font from the design tokens
// in style.css, so a tour's enterprise branding (branding.js) restyles all of it.
import { guideCard } from './guide.js';

const ICON = {
    walk: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="13" cy="4" r="2"/><path d="M10 22l2-7 3 3v6M8 12l2-4 4 1 3 4M14 9l-2 6"/></svg>',
    overview: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9l9-6 9 6v11H3z"/><path d="M9 20v-6h6v6"/></svg>',
    full: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>',
    unfull: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5"/></svg>',
    tour: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z"/></svg>',
    stop: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="1.5"/></svg>',
    // A phone between two turning arcs; a headset
    gyro: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8.5" y="4.5" width="7" height="15" rx="1.6"/><path d="M5 8.5a7.5 7.5 0 0 0 0 7M19 8.5a7.5 7.5 0 0 1 0 7M3.6 14.2 5 15.5l1.6-1M20.4 9.8 19 8.5l-1.6 1"/></svg>',
    vr: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 7.5h15A1.5 1.5 0 0 1 21 9v6a1.5 1.5 0 0 1-1.5 1.5h-4.2l-1.8-2.2h-3l-1.8 2.2H4.5A1.5 1.5 0 0 1 3 15V9a1.5 1.5 0 0 1 1.5-1.5z"/><circle cx="8" cy="11.8" r="1.6"/><circle cx="16" cy="11.8" r="1.6"/></svg>',
    more: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle class="dot" cx="5.5" cy="12" r="1.6"/><circle class="dot" cx="12" cy="12" r="1.6"/><circle class="dot" cx="18.5" cy="12" r="1.6"/></svg>',
    room: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 20V5.5A1.5 1.5 0 0 1 6.5 4h11A1.5 1.5 0 0 1 19 5.5V20M3 20h18"/><path d="M14.5 12.5h.01"/></svg>',
    down: '<svg class="chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 14.5l5-5 5 5"/></svg>',
    next: '<svg class="chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 7l5 5-5 5"/></svg>',
    help: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.5 2.5 0 0 1 4.8 1c0 1.7-2.4 2.1-2.4 3.6M12 17.2h.01"/></svg>',
    quality: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2.2"/><circle cx="9" cy="17" r="2.2"/></svg>',
    alert: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4 21 19.5H3z"/><path d="M12 10v4.5M12 17h.01"/></svg>',
    sun: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>',
    // Time of day: the capture, the sun low in the east, high, low in the west
    capture: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8.5A1.5 1.5 0 0 1 5.5 7h2.2l1.4-2h5.8l1.4 2h2.2A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5z"/><circle cx="12" cy="13" r="3.2"/></svg>',
    rise: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 18h18M7.5 18a4.5 4.5 0 0 1 9 0M12 6v3M5.6 10.6l1.6 1.6M18.4 10.6l-1.6 1.6M9.5 4.5 12 2l2.5 2.5"/></svg>',
    noon: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4"/></svg>',
    set: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 18h18M7.5 18a4.5 4.5 0 0 1 9 0M12 6v3M5.6 10.6l1.6 1.6M18.4 10.6l-1.6 1.6M9.5 3.5 12 6l2.5-2.5"/></svg>'
};
// Small pictures in front of a toast
const TOAST_ICON = {
    esc: '<kbd>Esc</kbd>',
    gyro: `<span class="ti ti-gyro">${ICON.gyro}</span>`,
    quality: `<span class="ti">${ICON.quality}</span>`,
    alert: `<span class="ti">${ICON.alert}</span>`
};
const SIDE = 14;   // px, the inset of everything floating (style.css --side)

/** Icon for a lighting option: the capture, or where the sun stands (low in the east, high, low in the west). */
function lightIcon(o) {
    if (!o.sun) return ICON.capture;
    if (o.sun.elevation >= 35) return ICON.noon;
    return o.sun.azimuth < 180 ? ICON.rise : ICON.set;
}

export class UI {
    constructor(root) {
        this.root = root;
        root.insertAdjacentHTML('beforeend', `
            <div class="tour-ui">
              <img class="poster" alt="" hidden>
              <div class="fade"></div>
              <div class="progress"><div class="bar"></div></div>
              <div class="loading" hidden><i class="spin"></i><span>Rundgang wird geladen</span></div>
              <div class="title"></div>
              <div class="lighting" role="toolbar" aria-label="Tageslicht" hidden></div>
              <div class="cards"></div>
              <div class="toasts" role="status" aria-live="polite"></div>
              <div class="dock" role="toolbar" aria-label="Rundgang">
                <button class="btn tour" type="button" hidden></button>
                <button class="btn room" type="button" aria-haspopup="menu" aria-expanded="false" hidden>${ICON.room}<span class="lbl">Räume</span>${ICON.down}</button>
                <button class="btn light" type="button" aria-haspopup="menu" aria-expanded="false" hidden><span class="li"></span><span class="lbl">Licht</span>${ICON.down}</button>
                <button class="btn mode" type="button"></button>
                <button class="btn vr" type="button" hidden>${ICON.vr}<span class="lbl">VR starten</span></button>
                <button class="btn more" type="button" aria-haspopup="menu" aria-expanded="false" aria-label="Mehr">${ICON.more}<span class="lbl">Mehr</span></button>
                <button class="btn full" type="button" aria-label="Vollbild" title="Vollbild">${ICON.full}<span class="lbl">Vollbild</span></button>
              </div>
              <div class="pop rooms-pop" role="menu" aria-label="Räume" hidden></div>
              <div class="pop menu" role="menu" aria-label="Mehr" hidden>
                <button class="item gyro" type="button" role="menuitemcheckbox" aria-checked="false" hidden>${ICON.gyro}<span>Bewegungssteuerung</span><i class="switch"></i></button>
                <button class="item vr" type="button" role="menuitem" hidden>${ICON.vr}<span>VR-Brille</span>${ICON.next}</button>
                <button class="item full" type="button" role="menuitem">${ICON.full}<span>Vollbild</span></button>
                <div class="item quality" hidden>${ICON.quality}<span>Bildqualität</span>
                  <div class="qseg" role="radiogroup" aria-label="Bildqualität"></div><small class="qnote"></small></div>
                <button class="item help" type="button" role="menuitem">${ICON.help}<span>Bedienung</span>${ICON.next}</button>
                <a class="credit" href="https://horama.de" target="_blank" rel="noopener nofollow" hidden></a>
              </div>
              <div class="crosshair"></div>
              <div class="fatal" role="alert" hidden></div>
            </div>`);
        const q = s => root.querySelector(s);
        this.el = {
            ui: q('.tour-ui'), cards: q('.cards'), poster: q('.poster'), fade: q('.fade'), progress: q('.progress'), bar: q('.bar'), loading: q('.loading'),
            title: q('.title'), lighting: q('.lighting'), toasts: q('.toasts'), dock: q('.dock'), tour: q('.btn.tour'), room: q('.btn.room'),
            light: q('.btn.light'), mode: q('.btn.mode'), vr: q('.btn.vr'), more: q('.btn.more'), full: q('.btn.full'),
            roomsPop: q('.rooms-pop'), menu: q('.menu'), gyro: q('.item.gyro'), vrItem: q('.item.vr'), fullItem: q('.item.full'),
            quality: q('.item.quality'), help: q('.item.help'), credit: q('.credit'), fatal: q('.fatal')
        };
        this.onMode = null;
        this.onTour = null;
        this.onGyro = null;
        this.onVr = null;
        this.titleText = '';
        this.titleHidden = false;
        this.touch = false;
        this.vrReady = false;
        this.pop = null;            // the open popover: 'rooms' | 'light' | 'menu'
        this.guide = null;          // the guide card on screen
        this.rooms = [];
        this.lightOptions = null;

        const el = this.el;
        el.tour.addEventListener('click', () => this.onTour?.());
        el.mode.addEventListener('click', () => this.onMode?.());
        el.room.addEventListener('click', () => this._toggle('rooms'));
        el.light.addEventListener('click', () => this._toggle('light'));
        el.more.addEventListener('click', () => this._toggle('menu'));
        el.vr.addEventListener('click', () => this._vr());
        el.vrItem.addEventListener('click', () => { this._close(); this._vr(); });
        el.gyro.addEventListener('click', () => { this._close(); this.onGyro?.(); });
        el.help.addEventListener('click', () => { this._close(); this.help(); });
        for (const b of [el.full, el.fullItem]) b.addEventListener('click', () => this._toggleFullscreen());
        if (!document.fullscreenEnabled && !document.webkitFullscreenEnabled) el.full.hidden = el.fullItem.hidden = true;
        const fsChange = () => {
            const on = !!(document.fullscreenElement || document.webkitFullscreenElement);
            el.full.innerHTML = `${on ? ICON.unfull : ICON.full}<span class="lbl">Vollbild</span>`;
            el.full.setAttribute('aria-label', on ? 'Vollbild beenden' : 'Vollbild');
            el.full.title = el.full.getAttribute('aria-label');
        };
        document.addEventListener('fullscreenchange', fsChange);
        document.addEventListener('webkitfullscreenchange', fsChange);

        // A press outside the open popover closes it; Esc closes popovers and cards
        root.addEventListener('pointerdown', (e) => {
            if (this.pop && !e.target.closest('.pop, .lighting, .btn.room, .btn.light, .btn.more')) this._close();
        }, true);
        addEventListener('keydown', (e) => {
            if (e.key !== 'Escape') return;
            if (this.pop) this._close(true);
            else if (this.guide) this.closeGuide();
        });
        // Layout that depends on measured sizes: where the time of day fits
        new ResizeObserver(() => this._layout()).observe(root);
    }

    setTitle(t) {
        this.titleText = t || '';
        this._renderTitle();
        document.title = t ? `${t} – 3D-Rundgang` : '3D-Rundgang';
    }

    /** Brand logo in the title badge (optionally instead of the text). */
    setLogo(url, alt = '', hideTitle = false) {
        this.logo = { url, alt, hideTitle };
        this._renderTitle();
    }

    _renderTitle() {
        const el = this.el.title;
        el.textContent = '';
        if (this.logo) {
            const img = document.createElement('img');
            img.src = this.logo.url;
            img.alt = this.logo.alt;
            img.addEventListener('load', () => this._layout());
            el.appendChild(img);
        }
        if (this.titleText && !this.logo?.hideTitle) {
            const s = document.createElement('span');
            s.textContent = this.titleText;
            el.appendChild(s);
        }
        el.hidden = this.titleHidden;
        this._layout();
    }

    /** Keep the badge off the picture (?title=0, e.g. a demo flat whose address is not the point). */
    hideTitle() {
        this.titleHidden = true;
        this._renderTitle();
    }

    /** Drone tour button; `active` switches it to a stop button. */
    setTour(available, active = false) {
        const b = this.el.tour;
        b.hidden = !available;
        b.classList.toggle('active', active);
        b.innerHTML = active ? `${ICON.stop}<span class="lbl">Tour beenden</span>` : `${ICON.tour}<span class="lbl">Tour</span>`;
        b.setAttribute('aria-pressed', String(active));
        this.tourAvailable = available;
    }

    /** Motion look switch in the menu (phones, tablets); `active` turns the switch on. */
    setGyro(available, active = false) {
        const b = this.el.gyro;
        b.hidden = !available;
        b.classList.toggle('active', active);
        b.setAttribute('aria-checked', String(active));
    }

    /**
     * VR: the menu explains it everywhere the viewer can do it; while the browser reports a headset, a button in the
     * dock starts it (after a card showing the controllers).
     */
    setVr(available) {
        this.vrReady = available;
        this.el.vr.hidden = !available;
        this.el.vrItem.hidden = false;
    }

    /** Picture quality in the menu. `options`: [{id, label}]; `onPick(id)`. */
    setQuality(options, current, note, onPick) {
        const seg = this.el.quality.querySelector('.qseg');
        seg.innerHTML = '';
        for (const o of options) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'q-opt';
            b.setAttribute('role', 'radio');
            b.dataset.q = o.id;
            b.textContent = o.label;
            b.addEventListener('click', () => onPick(o.id));
            seg.appendChild(b);
        }
        this.el.quality.hidden = false;
        this.setCurrentQuality(current, note);
    }

    setCurrentQuality(id, note = '') {
        for (const b of this.el.quality.querySelectorAll('.q-opt')) {
            b.classList.toggle('current', b.dataset.q === id);
            b.setAttribute('aria-checked', String(b.dataset.q === id));
        }
        this.el.quality.querySelector('.qnote').textContent = note;
    }

    /**
     * Horama at the foot of the menu: "3D-Rundgang von Horama", or under a brand of its own (whose logo takes the
     * place) a quiet "Technik: Horama". nofollow: the tour sits on the agent's website, a widget link.
     */
    setCredit(branded) {
        const c = this.el.credit;
        c.classList.toggle('quiet', branded);
        c.innerHTML = branded ? 'Technik: Horama' : '3D-Rundgang von <b>Horama</b>';
        c.hidden = false;
    }

    /** Light surfaces for weak graphics: no blur behind the glass (it is redrawn with every frame). */
    setLite(on) {
        this.root.classList.toggle('lite', on);
    }

    showPoster(url) {
        const p = this.el.poster;
        p.src = url;
        p.hidden = false;
    }

    hidePoster(delay = 0) {
        setTimeout(() => {
            this.el.poster.classList.add('gone');
            setTimeout(() => { this.el.poster.hidden = true; }, 1200);
        }, delay);
    }

    /** "Rundgang wird geladen" while nothing is drawn yet; shown only if that takes a moment. */
    loading(on) {
        clearTimeout(this.loadingTimer);
        if (on) this.loadingTimer = setTimeout(() => { this.el.loading.hidden = false; }, 700);
        else this.el.loading.classList.add('gone');
    }

    setProgress(done, total, finished) {
        this.el.progress.classList.add('on');
        this.el.bar.style.width = `${Math.round((done / Math.max(total, 1)) * 100)}%`;
        if (finished) setTimeout(() => this.el.progress.classList.remove('on'), 600);
    }

    setMode(mode, walkAvailable = true) {
        const b = this.el.mode;
        b.hidden = !walkAvailable;
        // The button offers the other mode
        b.innerHTML = mode === 'walk' ? `${ICON.overview}<span class="lbl">Überblick</span>` : `${ICON.walk}<span class="lbl">Gehen</span>`;
        this.root.classList.toggle('mode-overview', mode === 'overview');
    }

    /** Rooms: a list above the dock; the dock's button names the room the visitor is in. */
    setRooms(rooms, onPick) {
        this.rooms = rooms || [];
        const pop = this.el.roomsPop;
        pop.innerHTML = '';
        for (const room of this.rooms) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'ritem';
            b.setAttribute('role', 'menuitemradio');
            b.dataset.room = room.id;
            b.textContent = room.name;
            b.addEventListener('click', () => { this._close(); onPick(room); });
            pop.appendChild(b);
        }
        this.el.room.hidden = !this.rooms.length;
        this.setCurrentRoom(this.currentRoom);
    }

    setCurrentRoom(id) {
        if (id === this.currentRoom && this.rooms.length === this.roomsShown) return;
        this.currentRoom = id;
        this.roomsShown = this.rooms.length;
        for (const b of this.el.roomsPop.children) {
            b.classList.toggle('current', b.dataset.room === id);
            b.setAttribute('aria-checked', String(b.dataset.room === id));
        }
        const name = this.rooms.find(r => r.id === id)?.name;
        this.el.room.querySelector('.lbl').textContent = name || 'Räume';
        this.el.room.setAttribute('aria-label', name ? `Raum: ${name}, anderen Raum wählen` : 'Räume');
    }

    /**
     * Time of day as one segmented switch (computed sunlight). `options`: [{id, label, time?, sun?}], the first
     * one is the capture. A thumb slides under the current option; the one loading pulses with a small ring. Where
     * the switch does not fit beside the title it folds into the dock: a button with the current time opens it as a
     * list.
     */
    setLighting(options, note, onPick) {
        this.lightOptions = options;
        const el = this.el.lighting;
        el.innerHTML = `<div class="seg" role="radiogroup" aria-label="Tageslicht"><span class="seg-thumb"></span></div>`;
        const seg = el.firstChild;
        for (const o of options) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'seg-opt';
            b.setAttribute('role', 'radio');
            b.dataset.light = o.id;
            if (o.time) b.title = `${o.label}, ${o.time}`;
            b.innerHTML = `${lightIcon(o)}<span>${o.label}</span><i class="ring"></i>`;
            b.addEventListener('click', () => {
                onPick(o.id);
                if (this.pop === 'light') setTimeout(() => this._close(), 350);
            });
            seg.appendChild(b);
        }
        if (note) {
            const n = document.createElement('span');
            n.className = 'lighting-note';
            n.textContent = note;
            el.appendChild(n);
        }
        el.hidden = false;
        this.root.classList.add('has-light');
        // Keep the thumb under its option when the font arrives or the window changes size
        new ResizeObserver(() => this._placeThumb(false)).observe(seg);
        this._layout();
    }

    setCurrentLighting(id, loadingId = null) {
        const el = this.el.lighting;
        for (const b of el.querySelectorAll('.seg-opt')) {
            b.classList.toggle('current', b.dataset.light === id);
            b.setAttribute('aria-checked', String(b.dataset.light === id));
            b.classList.toggle('loading', b.dataset.light === loadingId);
        }
        el.classList.toggle('busy', !!loadingId);
        // The simulation note only under a computed time, not under the capture
        el.classList.toggle('sim', id !== el.querySelector('.seg-opt')?.dataset.light);
        // The dock's button (folded switch) shows the time on screen; under the capture it just says "Licht"
        const o = this.lightOptions?.find(x => x.id === id);
        if (o) {
            this.el.light.querySelector('.li').innerHTML = lightIcon(o);
            this.el.light.querySelector('.lbl').textContent = o.sun ? o.label : 'Licht';
            this.el.light.classList.toggle('loading', !!loadingId);
            this.el.light.setAttribute('aria-label', `Tageslicht: ${o.label}`);
        }
        this._placeThumb(true);
    }

    _placeThumb(animate) {
        const seg = this.el.lighting.querySelector('.seg');
        const cur = seg?.querySelector('.seg-opt.current');
        if (!cur || !cur.offsetWidth) return;
        const t = seg.firstChild;
        if (!animate) t.style.transition = 'none';
        t.style.width = `${cur.offsetWidth}px`;
        t.style.height = `${cur.offsetHeight}px`;
        t.style.transform = `translate(${cur.offsetLeft}px, ${cur.offsetTop}px)`;
        if (!animate) { t.getBoundingClientRect(); t.style.transition = ''; }
    }

    /** The time-of-day switch stays at the top while it fits between the title and the edge, else folds into the dock. */
    _layout() {
        const L = this.el.lighting;
        if (!this.lightOptions || L.hidden) return;
        const was = this.root.classList.contains('light-fold');
        this.root.classList.remove('light-fold');
        const need = L.querySelector('.seg').offsetWidth;
        const title = this.el.title.hidden ? 0 : this.el.title.offsetWidth;
        const fold = need + 2 * (SIDE + title + 12) > this.root.clientWidth;
        this.root.classList.toggle('light-fold', fold);
        this.el.light.hidden = !fold;
        if (was !== fold && this.pop === 'light') this._close();
        this._placeThumb(false);
    }

    // --- popovers above the dock: rooms, time of day (folded), the menu ---

    _toggle(name) {
        if (this.pop === name) return this._close(true);
        this._close();
        // The visitor found the dock: the guide has done its job
        if (this.guide) this.closeGuide();
        const [pop, btn] = this._popOf(name);
        this.pop = name;
        pop.hidden = false;
        pop.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('open');
        this._anchor(pop, btn);
        if (name === 'light') this._placeThumb(false);
        // Keyboard users land on the current entry (or the first)
        if (btn.matches(':focus-visible')) (pop.querySelector('.current') || pop.querySelector('button'))?.focus();
    }

    _close(refocus = false) {
        if (!this.pop) return;
        const [pop, btn] = this._popOf(this.pop);
        this.pop = null;
        pop.classList.remove('open');
        if (pop !== this.el.lighting) pop.hidden = true;
        pop.style.left = pop.style.bottom = '';
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('open');
        if (refocus) btn.focus({ preventScroll: true });
    }

    _popOf(name) {
        const e = this.el;
        return name === 'rooms' ? [e.roomsPop, e.room] : name === 'light' ? [e.lighting, e.light] : [e.menu, e.more];
    }

    /** Above its button, kept inside the frame */
    _anchor(pop, btn) {
        const r = this.root.getBoundingClientRect(), b = btn.getBoundingClientRect();
        const w = pop.offsetWidth;
        const left = Math.min(Math.max(b.left + b.width / 2 - r.left - w / 2, SIDE), r.width - SIDE - w);
        pop.style.left = `${Math.max(SIDE, left)}px`;
        pop.style.bottom = `${r.bottom - this.el.dock.getBoundingClientRect().top + 10}px`;
    }

    // --- guide cards: how to move, VR ---

    /**
     * Once the room is ready: the dock appears, then the guide for this device. It stays until the visitor moves
     * (a press on the picture, a key) or closes it; `guide: false` leaves it out (stills, presentations).
     */
    ready(touch, { guide = true } = {}) {
        this.touch = touch;
        this.el.loading.classList.add('gone');
        this.root.classList.add('ready');
        this.root.classList.toggle('touch', touch);
        if (touch) this.root.classList.add('stick-labels');
        if (guide) setTimeout(() => this.help({ auto: true }), 450);
        else this._labelsOff();
    }

    /** The guide for this device again (menu: Bedienung) */
    help({ auto = false } = {}) {
        const upright = this.touch && matchMedia('(orientation: portrait)').matches;
        const actions = [{ label: 'Los geht’s', primary: true }];
        if (this.tourAvailable) actions.unshift({ label: 'Tour starten', play: true, run: () => this.onTour?.() });
        this.showGuide(this.touch ? 'touch' : 'mouse', { upright, actions, untilUse: true, auto });
    }

    /**
     * A guide card in the middle. `opts.actions`: [{label, primary?, play?, run?}], each closes the card;
     * `opts.untilUse`: closes too when the visitor starts moving; `opts.timeout`: closes by itself after so many ms.
     */
    showGuide(kind, opts = {}) {
        this.closeGuide(true);
        const actions = (opts.actions ?? []).map(a => ({ ...a, run: () => { this.closeGuide(); a.run?.(); } }));
        const card = guideCard(kind, { upright: opts.upright, actions });
        card.querySelector('.x').addEventListener('click', () => this.closeGuide());
        this.el.cards.appendChild(card);
        this.guide = card;
        if (opts.untilUse) {
            const use = (e) => {
                if (e.type === 'keydown' ? ['Tab', 'Shift', 'Enter', ' ', 'Escape'].includes(e.key) || e.target.closest?.('.card')
                    : e.target.closest('.card, .dock, .pop, .lighting, .title')) return;
                this.closeGuide();
            };
            this.root.addEventListener('pointerdown', use, true);
            addEventListener('keydown', use, true);
            card._off = () => { this.root.removeEventListener('pointerdown', use, true); removeEventListener('keydown', use, true); };
        }
        if (opts.timeout) setTimeout(() => { if (this.guide === card) this.closeGuide(); }, opts.timeout);
        if (!opts.auto) (card.querySelector('.actions .cta:last-child') ?? card.querySelector('.x')).focus({ preventScroll: true });
    }

    closeGuide(now = false) {
        const card = this.guide;
        if (!card) return;
        this.guide = null;
        card._off?.();
        if (now) card.remove();
        else { card.classList.add('gone'); setTimeout(() => card.remove(), 400); }
        this._labelsOff(9000);
    }

    _labelsOff(after = 0) {
        clearTimeout(this.labelsTimer);
        this.labelsTimer = setTimeout(() => this.root.classList.remove('stick-labels'), after);
    }

    /** VR: with a headset the controllers' card and "VR starten", without one how to get there */
    _vr() {
        if (this.vrReady) {
            this.showGuide('vr', { actions: [{ label: 'Abbrechen' }, { label: 'VR starten', primary: true, run: () => this.onVr?.() }] });
        } else {
            this.showGuide('vrInfo', { actions: [{ label: 'Verstanden', primary: true }] });
        }
    }

    // --- messages ---

    /** A short message at the top; `icon`: esc | gyro | quality | alert. Stays longer the longer the text. */
    notice(text, icon) {
        const t = document.createElement('div');
        t.className = 'toast';
        if (TOAST_ICON[icon]) t.innerHTML = TOAST_ICON[icon];
        const s = document.createElement('span');
        s.textContent = text;
        t.appendChild(s);
        const box = this.el.toasts;
        while (box.children.length >= 2) box.firstChild.remove();
        box.appendChild(t);
        const ms = Math.min(9000, Math.max(4000, 2000 + text.length * 60));
        setTimeout(() => { t.classList.add('gone'); setTimeout(() => t.remove(), 500); }, ms);
    }

    fatal(text) {
        this.el.loading.classList.add('gone');
        this.el.fatal.innerHTML = ICON.alert;
        const s = document.createElement('span');
        s.textContent = text;
        this.el.fatal.appendChild(s);
        this.el.fatal.hidden = false;
    }

    /** Fade to the background colour, run fn, fade back. */
    fade(fn) {
        const f = this.el.fade;
        f.classList.add('on');
        setTimeout(() => {
            fn();
            setTimeout(() => f.classList.remove('on'), 120);
        }, 260);
    }

    tapMarker(x, y, failed = false) {
        const d = document.createElement('div');
        d.className = failed ? 'tap fail' : 'tap';
        d.style.left = `${x}px`;
        d.style.top = `${y}px`;
        this.el.ui.appendChild(d);
        setTimeout(() => d.remove(), 700);
    }

    /** Small diagnostics line (?debug=1), refreshed twice a second. */
    debugOverlay(text) {
        const d = document.createElement('div');
        d.className = 'debug';
        this.el.ui.appendChild(d);
        setInterval(() => { d.textContent = text(); }, 500);
    }

    _toggleFullscreen() {
        const doc = document;
        this._close();
        if (doc.fullscreenElement || doc.webkitFullscreenElement) {
            (doc.exitFullscreen || doc.webkitExitFullscreen).call(doc);
        } else {
            const el = this.root;
            (el.requestFullscreen || el.webkitRequestFullscreen).call(el);
        }
    }
}
